import React, {Component,ReactNode} from 'react'

export const ErrorFallbackComponent = ({ error, componentStack, resetErrorBoundary }) => {
    return (
        <div>
            <h1>An error occurred: {error.message}</h1>

        </div>
    );
};
interface Props {
    children?: ReactNode;
}

interface State {
    error: any;
}
export class ErrorBoundary extends Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {error: ""};
    }

    componentDidCatch(error) {
        console.log("***ERROR***", error.name, error.message, error.stack)
        this.setState({error: `${error.name}: ${error.message}`});
    }

    render() {
        const {error} = this.state;
        if (error) {
            return (
                <div className={'flex justify-content-center'}>{error}</div>
            );
        } else {
            return <>{this.props.children}</>;
        }
    }
}